// extracted by mini-css-extract-plugin
export default {"outer":"scrollbox_outer__3RRTe","inner":"scrollbox_inner__IdETu","disabled":"scrollbox_disabled__9bYck","vertical":"scrollbox_vertical__IrBE4","tray":"scrollbox_tray__Xg-Ii"};